import { AspectRatio } from "@radix-ui/themes";

interface ImageProps {
  src: string;
  alt: string;
  className?: string;
  ratio?: number;
}

export const Image = ({ src, alt, className, ratio = 16 / 8 }: ImageProps) => {
  return (
    <AspectRatio ratio={ratio}>
      <img src={src} alt={alt} className={className} />
    </AspectRatio>
  );
};
